import { PropsWithChildren } from "react";

import { ActivityCompareStoreProvider } from "./activity_compare";
import { ActivityTabsStoreProvider } from "./activity_tabs";
import { MatchesStoreProvider } from "./matches";
import { ShortlistsStoreProvider } from "./shortlists";

export const ActivityShowStoreProvider = ({ children }: PropsWithChildren) => (
  <ActivityTabsStoreProvider>
    <ActivityCompareStoreProvider>
      <MatchesStoreProvider>
        <ShortlistsStoreProvider>{children}</ShortlistsStoreProvider>
      </MatchesStoreProvider>
    </ActivityCompareStoreProvider>
  </ActivityTabsStoreProvider>
);
